import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { Expense } from '@/types/expense';
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";

interface CategoryPieChartProps {
  expenses: Expense[];
  totalExpenses: number;
}

const COLORS = ['#9b87f5', '#7E69AB', '#B4A0E5', '#6B4F9E', '#D6BCFA', '#553C9A'];

export const CategoryPieChart = ({ expenses, totalExpenses }: CategoryPieChartProps) => {
  const originalExpenses = expenses.filter(expense => !expense.description.includes('(Split'));
  
  const categoryTotals = originalExpenses.reduce((acc, expense) => {
    acc[expense.category] = (acc[expense.category] || 0) + Number(expense.amount);
    return acc;
  }, {} as Record<string, number>);

  const chartData = Object.entries(categoryTotals).map(([name, value]) => ({
    name,
    value,
    percentage: ((value / totalExpenses) * 100).toFixed(1)
  }));

  return (
    <ScrollArea className="w-full h-full">
      <div className="min-w-[300px] md:min-w-[600px] h-[400px] p-4">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart className="bg-gradient-to-br from-white/95 to-white/90 backdrop-blur-sm rounded-lg shadow-lg">
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              labelLine={true}
              outerRadius={120}
              innerRadius={60}
              fill="#8884d8"
              dataKey="value"
              label={({ name, percentage }) => {
                const truncatedName = name.length > 15 ? name.slice(0, 15) + '...' : name;
                return `${truncatedName} (${percentage}%)`;
              }}
            >
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip 
              formatter={(value: number) => `₹${value.toFixed(2)}`}
              contentStyle={{ 
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                borderRadius: '8px',
                border: '1px solid #e2e8f0',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
              }}
            />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <ScrollBar orientation="horizontal" />
    </ScrollArea>
  );
};